/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdEmployeeDataQueryResponse,
  GetApiV1PersonIdEmployeeDataPathParams,
  GetApiV1PersonIdEmployeeData401,
  GetApiV1PersonIdEmployeeData404,
  GetApiV1PersonIdEmployeeData500,
} from "../../types/personEmployeeController/GetApiV1PersonIdEmployeeData.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonIdEmployeeData } from "../../clients/personEmployeeController/getApiV1PersonIdEmployeeData.ts";

export const getApiV1PersonIdEmployeeDataQueryKey = (
  id: GetApiV1PersonIdEmployeeDataPathParams["id"],
) => [{ url: "/api/v1/person/:id/employee-data", params: { id: id } }] as const;

export type GetApiV1PersonIdEmployeeDataQueryKey = ReturnType<
  typeof getApiV1PersonIdEmployeeDataQueryKey
>;

export function getApiV1PersonIdEmployeeDataQueryOptions(
  id: GetApiV1PersonIdEmployeeDataPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonIdEmployeeDataQueryKey(id);
  return queryOptions<
    GetApiV1PersonIdEmployeeDataQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdEmployeeData401
      | GetApiV1PersonIdEmployeeData404
      | GetApiV1PersonIdEmployeeData500
    >,
    GetApiV1PersonIdEmployeeDataQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonIdEmployeeData(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados da aba Employee da pessoa (cargo, crachá, admissão, demissão, tipo e notificação de chamado). **(Requer Authorization para autenticação)**
 * @summary Obter dados de funcionário (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/employee-data}
 */
export function useGetApiV1PersonIdEmployeeData<
  TData = GetApiV1PersonIdEmployeeDataQueryResponse,
  TQueryData = GetApiV1PersonIdEmployeeDataQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonIdEmployeeDataQueryKey,
>(
  id: GetApiV1PersonIdEmployeeDataPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdEmployeeDataQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonIdEmployeeData401
          | GetApiV1PersonIdEmployeeData404
          | GetApiV1PersonIdEmployeeData500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1PersonIdEmployeeDataQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1PersonIdEmployeeDataQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonIdEmployeeData401
      | GetApiV1PersonIdEmployeeData404
      | GetApiV1PersonIdEmployeeData500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
